import {GameManager} from "../managers/GameManager";
import {OptionId, SlotId, StoryVO, StoryVOProvider} from "./StoryModel";

export interface StoryPromptVOProviderRule {
    slot?: SlotId;
    option?: OptionId | OptionId[];
    vo?: StoryVO;
    cc?: string;
}

export class StoryPromptVOProvider implements StoryVOProvider {

    private readonly _rules: StoryPromptVOProviderRule[];

    constructor(...rules: StoryPromptVOProviderRule[]) {
        this._rules = rules;
    }

    public getVO(): StoryVO | undefined {
        return this.getRule()?.vo;
    }

    public getCC(): string {
        return this.getRule()?.cc ?? "";
    }

    private getRule() {
        const gameManager = GameManager.instance;
        for (const rule of this._rules) {
            const slotId = rule.slot;
            const optionId = rule.option;
            if ((!slotId && !optionId) ||
                (typeof optionId === "string" && gameManager.isOptionSelected(optionId, slotId)) ||
                (typeof optionId === "object" && optionId.some((it) => gameManager.isOptionSelected(it, slotId)))) {
                return rule;
            }
        }
        return undefined;
    }
}
